module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrap",
    staticClass: "detail-wrap",
    style: (_vm.txtStyle),
    on: {
      "touchstart": _vm._touchStart,
      "touchmove": _vm._touchMove,
      "touchend": _vm._touchEnd
    }
  }, [(_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "content"
  }, [(_vm.GoodsDetail.length < 1 && !_vm.load) ? _c('empty', {
    attrs: {
      "emptytext": "对不起，暂时没有找到结果"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.GoodsDetail), function(goodItem, index) {
    return (goodItem.infoType == 1) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(goodItem.infos)
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.height > 0),
      expression: "height>0"
    }],
    staticClass: "tripartite-box",
    style: (_vm.txtStyle)
  }, [_c('span', {
    staticClass: "wxauth-title"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.tip) + "\n\t\t\t")])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04a00b73","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/classify/detail.vue
// module id = 373
// module chunks = 68